import LandingStepArrow from './landing-step-arrow';

export default LandingStepArrow;
